import {
    BASEMAP_DARK_GRAY_IMAGE,
    BASEMAP_IMAGERY_IMAGE,
    BASEMAP_STREET_IMAGE,
    BASEMAP_TOPO_IMAGE,
    BASEMAP_OSM,
    TOC_BILLBOARD_SVG_ICON,
    TOC_CONDO_SVG_ICON,
    TOC_DISTRICT_SVG_ICON,
    TOC_EXEMPT_SVG_ICON,
    TOC_HOUSE_SVG_ICON,
    TOC_LAND_SVG_ICON,
    TOC_PROVINCE_SVG_ICON,
    TOC_SUB_DISTRICT_SVG_ICON,
    TOC_SURVEYED_SVG_ICON,
    TOC_UNSURVEYED_SVG_ICON,
} from './logo';

export const defaultBaseMapID = 1;
export const measurementDecimalDigit = 2;
export const coordinateDecimalDigit = 5;

export const graphicLayerId = {
    measurementLayer: 'measureLayer',
    measurementAreaLayer: 'measureAreaLayer',
    measurementLengthLayer: 'measureLengthLayer',
    checkTaxLayer: 'checkTaxLayer',
    highlightLayer: 'highlightLayer',
    highlightAssetLayer: 'highlightLayer',
};

export const measurementDrawMode = {
    point: 'point',
    distance: 'distance',
    area: 'area',
};

export const measurementUnit = {
    point: [
        {
            nameTH: 'Latitude, Longitude',
            nameEN: 'lat-long',
            unitTH: '',
        },
    ],
    distance: [
        {
            nameEN: 'kilometers',
            nameTH: 'กิโลเมตร',
            unitTH: 'กม.',
        },
        {
            nameEN: 'meters',
            nameTH: 'เมตร',
            unitTH: 'ม.',
        },
        {
            nameEN: 'yards',
            nameTH: 'หลา',
            unitTH: 'หลา',
        },
        {
            nameEN: 'feet',
            nameTH: 'ฟุต',
            unitTH: 'ฟุต',
        },
        {
            nameEN: 'inch',
            nameTH: 'นิ้ว',
            unitTH: 'นิ้ว',
        },
    ],
    area: [
        {
            nameEN: 'square-kilometers',
            nameTH: 'ตารางกิโลเมตร',
            unitTH: 'ตร.กม.',
        },
        {
            nameEN: 'square-meters',
            nameTH: 'ตารางเมตร',
            unitTH: 'ตรม.',
        },
        {
            nameEN: 'square-wa',
            nameTH: 'ตารางวา',
            unitTH: 'ตรว.',
        },
        {
            nameEN: 'rai',
            nameTH: 'ไร่',
            unitTH: 'ไร่',
        },
        {
            nameEN: 'nagn',
            nameTH: 'งาน',
            unitTH: 'งาน',
        },
        {
            nameEN: 'wa',
            nameTH: 'วา',
            unitTH: 'วา',
        },
    ],
};

export const basemapImage = [
    {
        id: 1,
        url: BASEMAP_STREET_IMAGE,
    },
    {
        id: 2,
        url: BASEMAP_IMAGERY_IMAGE,
    },
    {
        id: 3,
        url: BASEMAP_TOPO_IMAGE,
    },
    {
        id: 4,
        url: BASEMAP_OSM,
    },
];

export const tocIcon = [
    {
        id: 1,
        url: TOC_LAND_SVG_ICON,
    },
    {
        id: 2,
        url: TOC_BILLBOARD_SVG_ICON,
    },
    {
        id: 3,
        url: TOC_HOUSE_SVG_ICON,
    },
    {
        id: 4,
        url: TOC_CONDO_SVG_ICON,
    },
    {
        id: 5,
        url: TOC_PROVINCE_SVG_ICON,
    },
    {
        id: 6,
        url: TOC_DISTRICT_SVG_ICON,
    },
    {
        id: 7,
        url: TOC_SUB_DISTRICT_SVG_ICON,
    },
    {
        id: 8,
        url: TOC_SURVEYED_SVG_ICON,
    },
    {
        id: 9,
        url: TOC_UNSURVEYED_SVG_ICON,
    },
    {
        id: 10,
        url: TOC_EXEMPT_SVG_ICON,
    },
];

export const visiblePropertyToc = [1, 2, 3, 4, 5, 6, 7];
export const visibleDistrictToc = [0, 8, 9, 10, 11];
